<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Chapter-Title-Page-Break--Body-">Contents</p>
<p class="center"></p><p class="center"><a href="#/section0008title"><b>The Great White Way</b></a></p>
<p class="center"></p><p class="center"><a href="#/section0009title"><b>The Man from London</b></a></p>
<p class="center"></p><p class="center"><span href="#/section0010title" title="Link target outside of Sample"><b>Sea Chase</b></span></p>
<p class="center"><span href="#/section0010" title="Link target outside of Sample">One: At Work By Midnight</span></p>
<p class="center"><span href="#/section00101" title="Link target outside of Sample">Two: Sailor’s Hands</span></p>
<p class="center"><span href="#/section00102" title="Link target outside of Sample">Three: The Best Man</span></p>
<p class="center"><span href="#/section00103" title="Link target outside of Sample">Four: Vulcan At His Forge</span></p>
<p class="center"><span href="#/section00104" title="Link target outside of Sample">Five: The Captain</span></p>
<p class="center"><span href="#/section00105" title="Link target outside of Sample">Six: Freighter Trash</span></p>
<p class="center"><span href="#/section00106" title="Link target outside of Sample">Seven: In Sheep’s Clothing</span></p>
<p class="center"><span href="#/section00107" title="Link target outside of Sample">Eight: The Mellow Moment</span></p>
<p class="center"><span href="#/section00108" title="Link target outside of Sample">Nine: The <i>Javelin</i>’s Master</span></p>
<p class="center"><span href="#/section00109" title="Link target outside of Sample">Ten: Bucket of Blood</span></p>
<p class="center"><span href="#/section001010" title="Link target outside of Sample">Eleven: The Specialist</span></p>
<p class="center"><span href="#/section001011" title="Link target outside of Sample">Twelve: Dead Ahead</span></p>
<p class="center"><span href="#/section001012" title="Link target outside of Sample">Thirteen: A Good Day’s Work</span></p>
<p class="center"></p><p class="center"><span href="#/section0011title" title="Link target outside of Sample"><b>The Wolf and the Eagle</b></span></p>
<p class="center"><span href="#/section0011" title="Link target outside of Sample">One</span></p>
<p class="center"><span href="#/section00111" title="Link target outside of Sample">Two</span></p>
<p class="center"><span href="#/section00112" title="Link target outside of Sample">Three</span></p>
<p class="center"><span href="#/section00113" title="Link target outside of Sample">Four</span></p>
<p class="center"><span href="#/section00114" title="Link target outside of Sample">Five</span></p>
<p class="center"></p><p class="center"><span href="#/section0012title" title="Link target outside of Sample"><b>Death of a Hunter</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0007.vue?2e946c2e